module.exports = __webpack_public_path__ + "static/img/guide_step_1.23cc90ed.png";